import { Icon, type IconName } from "./Icon";
import "./Tabs.css";

export type TabItem<T extends string = string> = {
  id: T;
  label: string;
  icon?: IconName;
  count?: number;
  disabled?: boolean;
};

type Props<T extends string> = {
  items: TabItem<T>[];
  active: T;
  onChange: (id: T) => void;
};

export function Tabs<T extends string>({ items, active, onChange }: Props<T>) {
  return (
    <div className="detail-tabs">
      {items.map((t) => (
        <button
          key={t.id}
          className={`emp-subtab ${active === t.id ? "active" : ""}`}
          onClick={() => !t.disabled && onChange(t.id)}
          disabled={t.disabled}
        >
          {t.icon && <Icon name={t.icon} size={14} />}
          {t.label}
          {t.count != null && <span className="count">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}
